<template>
  <div
    :class="{
      'status': true,
      'status--active': isActive,
      'mb-4': !isFlat,
      'status--flat': isFlat,
      'status--flat-active': isFlat && isActive,
    }"
  >
    <div
      :class="{
        'flex items-center': !isFlat,
      }"
    >
      <span
        v-if="!isFlat"
        class="status__active-bar"
        :class="{
          'bg-primary-90': isActive
        }"
      />

      <slot />

      <span class="status__note">(<AhaFormatter
        type="number"
        :value="note"
      />)</span>
    </div>

    <div
      v-if="isFlat"
      class="status__active-bar--flat"
      :class="{
        'bg-primary-90': isActive
      }"
    />
  </div>
</template>

<script>
export default {
  props: {
    note: {
      type: Number,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    isFlat: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.status {
  @apply text-sm sm:text-base text-base-0 mx-2 capitalize whitespace-nowrap;

  .status__note {
    @apply ml-1 text-xs sm:text-base;

    color: rgba(255, 255, 255, 0.65);
  }
}

.status--active {
  @apply font-bold;

  .status__note {
    @apply text-base-0 font-normal;
  }
}

.status--flat {
  @apply inline-flex flex-col;
}

.status--flat-active {
  @apply text-brand-a100;

  .status__note {
    @apply text-brand-a100;
  }
}

.status__active-bar {
  @apply inline-block mr-3;

  border-radius: 2px;
  width: 4px;
  height: 24px;
}

.status__active-bar--flat {
  @apply mt-4;

  border-radius: 2px;
  width: 100%;
  height: 3px;
}
</style>
